var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _radialGradient, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _radialGradient2, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _radialGradient3, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _radialGradient4, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _radialGradient5, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _radialGradient6, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _radialGradient7, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _radialGradient8, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _radialGradient9, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _radialGradient10, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _radialGradient11, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _radialGradient12, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _radialGradient13, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _radialGradient14, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _radialGradient15, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _linearGradient110, _linearGradient111, _radialGradient16, _linearGradient112, _linearGradient113, _linearGradient114, _linearGradient115, _linearGradient116, _linearGradient117, _radialGradient17, _linearGradient118, _linearGradient119, _linearGradient120, _linearGradient121, _linearGradient122, _linearGradient123, _radialGradient18, _linearGradient124, _linearGradient125, _linearGradient126, _linearGradient127, _linearGradient128, _linearGradient129, _radialGradient19, _linearGradient130, _linearGradient131, _linearGradient132, _linearGradient133, _linearGradient134, _linearGradient135, _linearGradient136, _radialGradient20, _linearGradient137, _linearGradient138, _linearGradient139, _linearGradient140, _linearGradient141, _linearGradient142, _radialGradient21, _linearGradient143, _linearGradient144, _linearGradient145, _linearGradient146, _linearGradient147, _linearGradient148, _radialGradient22, _linearGradient149, _linearGradient150, _linearGradient151, _linearGradient152, _linearGradient153, _linearGradient154, _radialGradient23, _linearGradient155, _linearGradient156, _linearGradient157, _linearGradient158, _linearGradient159, _linearGradient160, _radialGradient24, _linearGradient161, _linearGradient162, _linearGradient163, _linearGradient164, _linearGradient165, _linearGradient166, _radialGradient25, _linearGradient167, _linearGradient168, _linearGradient169, _linearGradient170, _linearGradient171, _linearGradient172, _radialGradient26, _linearGradient173, _linearGradient174, _linearGradient175, _linearGradient176, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBarrel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#b78154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.766,
    x2: 295.972,
    xlinkHref: "#lg1",
    y1: 193.426,
    y2: 268.474
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.44,
    x2: 471.536,
    xlinkHref: "#lg1",
    y1: 227.145,
    y2: 281.491
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.254,
    x2: 415.687,
    xlinkHref: "#lg1",
    y1: 237.547,
    y2: 274.047
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.144,
    x2: 303.228,
    xlinkHref: "#lg1",
    y1: 231.587,
    y2: 293.594
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.375,
    x2: 384.395,
    xlinkHref: "#lg1",
    y1: 222.389,
    y2: 299.594
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.098,
    x2: 435.38,
    xlinkHref: "#lg2",
    y1: 304.602,
    y2: 847.672
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.851,
    x2: 225.213,
    xlinkHref: "#lg2",
    y1: 245.05,
    y2: -102.079
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.635,
    x2: 205.751,
    xlinkHref: "#lg2",
    y1: 188.851,
    y2: -483.911
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 7.274,
    y2: 28.128
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.111,
    x2: 120.111,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.847,
    x2: 96.673,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.325
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#ffd744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6278,
    stopColor: "#ffcf3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7926,
    stopColor: "#ffc237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    stopColor: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 116.987,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.287,
    x2: 111.905,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.996,
    x2: 109.018,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.72,
    x2: 144.93,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.111,
    x2: 120.111,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.288,
    x2: 174.288,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.024,
    x2: 150.85,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.324
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 171.164,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.464,
    x2: 166.082,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.173,
    x2: 163.195,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.897,
    x2: 199.107,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.288,
    x2: 174.288,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.466,
    x2: 228.466,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.201,
    x2: 205.027,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.325
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 225.341,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.641,
    x2: 220.26,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.35,
    x2: 217.372,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.074,
    x2: 253.284,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.465,
    x2: 228.465,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.643,
    x2: 282.643,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.378,
    x2: 259.204,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.324
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 279.518,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.818,
    x2: 274.437,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.527,
    x2: 271.549,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.251,
    x2: 307.461,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.643,
    x2: 282.643,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.82,
    x2: 336.82,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.555,
    x2: 313.381,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.325
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 333.695,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.995,
    x2: 328.614,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.704,
    x2: 325.726,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.428,
    x2: 361.638,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.82,
    x2: 336.82,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.997,
    x2: 390.997,
    xlinkHref: "#lg3",
    y1: 35.545,
    y2: -20.404
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.733,
    x2: 367.558,
    xlinkHref: "#lg2",
    y1: 45.85,
    y2: -2.324
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_47_",
    cx: 387.872,
    cy: 16.948,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.172,
    x2: 382.791,
    xlinkHref: "#lg3",
    y1: 31.283,
    y2: 8.921
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.881,
    x2: 379.903,
    xlinkHref: "#lg5",
    y1: 22.999,
    y2: 10.021
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.605,
    x2: 415.815,
    xlinkHref: "#lg6",
    y1: 21.522,
    y2: 4.416
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.997,
    x2: 390.997,
    xlinkHref: "#lg7",
    y1: 17.778,
    y2: 7.548
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 477.954,
    y2: 498.807
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.111,
    x2: 120.111,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.67,
    x2: 99.197,
    xlinkHref: "#lg2",
    y1: 511.346,
    y2: 470.873
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_55_",
    cx: 116.987,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.287,
    x2: 111.905,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.996,
    x2: 109.018,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.72,
    x2: 144.93,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.111,
    x2: 120.111,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.288,
    x2: 174.288,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.845,
    x2: 153.372,
    xlinkHref: "#lg2",
    y1: 511.35,
    y2: 470.877
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_62_",
    cx: 171.164,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.464,
    x2: 166.082,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.173,
    x2: 163.195,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.897,
    x2: 199.107,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.288,
    x2: 174.288,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.466,
    x2: 228.466,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.023,
    x2: 207.547,
    xlinkHref: "#lg2",
    y1: 511.35,
    y2: 470.875
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_69_",
    cx: 225.341,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.641,
    x2: 220.259,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.35,
    x2: 217.372,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.074,
    x2: 253.284,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.465,
    x2: 228.465,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.643,
    x2: 282.643,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.201,
    x2: 261.726,
    xlinkHref: "#lg2",
    y1: 511.35,
    y2: 470.875
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_76_",
    cx: 279.518,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.818,
    x2: 274.437,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.527,
    x2: 271.549,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.251,
    x2: 307.461,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.643,
    x2: 282.643,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.82,
    x2: 336.82,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.378,
    x2: 315.903,
    xlinkHref: "#lg2",
    y1: 511.351,
    y2: 470.876
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_83_",
    cx: 333.695,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.995,
    x2: 328.614,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.704,
    x2: 325.726,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.428,
    x2: 361.638,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.82,
    x2: 336.82,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.997,
    x2: 390.997,
    xlinkHref: "#lg3",
    y1: 506.224,
    y2: 450.275
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.621,
    x2: 370.539,
    xlinkHref: "#lg2",
    y1: 510.411,
    y2: 471.329
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_90_",
    cx: 387.872,
    cy: 487.627,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.172,
    x2: 382.791,
    xlinkHref: "#lg3",
    y1: 501.962,
    y2: 479.6
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.881,
    x2: 379.903,
    xlinkHref: "#lg5",
    y1: 493.678,
    y2: 480.7
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.605,
    x2: 415.815,
    xlinkHref: "#lg6",
    y1: 492.201,
    y2: 475.095
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.997,
    x2: 390.997,
    xlinkHref: "#lg7",
    y1: 488.457,
    y2: 478.227
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.723,
    x2: 232.855,
    xlinkHref: "#lg2",
    y1: 430.744,
    y2: 180.374
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 348.692,
    y2: 369.546
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.285,
    x2: 97.285,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.844,
    x2: 76.371,
    xlinkHref: "#lg2",
    y1: 382.084,
    y2: 341.612
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_99_",
    cx: 94.16,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.46,
    x2: 89.079,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.17,
    x2: 86.192,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.894,
    x2: 122.103,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.285,
    x2: 97.285,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.462,
    x2: 151.462,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.018,
    x2: 130.545,
    xlinkHref: "#lg2",
    y1: 382.089,
    y2: 341.616
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_106_",
    cx: 148.338,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.638,
    x2: 143.256,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.347,
    x2: 140.369,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.071,
    x2: 176.28,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.462,
    x2: 151.462,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.639,
    x2: 205.639,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.196,
    x2: 184.721,
    xlinkHref: "#lg2",
    y1: 382.088,
    y2: 341.613
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_113_",
    cx: 202.515,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.815,
    x2: 197.433,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.524,
    x2: 194.546,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.248,
    x2: 230.457,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.639,
    x2: 205.639,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.816,
    x2: 259.816,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.374,
    x2: 238.899,
    xlinkHref: "#lg2",
    y1: 382.089,
    y2: 341.613
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_120_",
    cx: 256.692,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.992,
    x2: 251.61,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.701,
    x2: 248.723,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.425,
    x2: 284.634,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.816,
    x2: 259.816,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.993,
    x2: 313.993,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.552,
    x2: 293.077,
    xlinkHref: "#lg2",
    y1: 382.089,
    y2: 341.614
  })), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_127_",
    cx: 310.869,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.169,
    x2: 305.787,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.878,
    x2: 302.9,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.602,
    x2: 338.811,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.993,
    x2: 313.993,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.17,
    x2: 368.17,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.795,
    x2: 347.712,
    xlinkHref: "#lg2",
    y1: 381.15,
    y2: 342.068
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_134_",
    cx: 365.046,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.346,
    x2: 359.964,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.055,
    x2: 357.077,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.779,
    x2: 392.988,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.17,
    x2: 368.17,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.662,
    x2: 422.662,
    xlinkHref: "#lg3",
    y1: 376.963,
    y2: 321.014
  })), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.287,
    x2: 402.204,
    xlinkHref: "#lg2",
    y1: 381.15,
    y2: 342.068
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_141_",
    cx: 419.538,
    cy: 358.366,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.838,
    x2: 414.456,
    xlinkHref: "#lg3",
    y1: 372.701,
    y2: 350.339
  })), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.547,
    x2: 411.569,
    xlinkHref: "#lg5",
    y1: 364.417,
    y2: 351.439
  })), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.271,
    x2: 447.48,
    xlinkHref: "#lg6",
    y1: 362.94,
    y2: 345.834
  })), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.662,
    x2: 422.662,
    xlinkHref: "#lg7",
    y1: 359.196,
    y2: 348.965
  })), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 136.536,
    y2: 157.389
  })), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.285,
    x2: 97.285,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.844,
    x2: 76.371,
    xlinkHref: "#lg2",
    y1: 169.928,
    y2: 129.455
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_149_",
    cx: 94.16,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.461,
    x2: 89.079,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.17,
    x2: 86.192,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.894,
    x2: 122.103,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.285,
    x2: 97.285,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient141 || (_linearGradient141 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.462,
    x2: 151.462,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient142 || (_linearGradient142 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.018,
    x2: 130.545,
    xlinkHref: "#lg2",
    y1: 169.932,
    y2: 129.459
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_156_",
    cx: 148.338,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient143 || (_linearGradient143 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.638,
    x2: 143.256,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient144 || (_linearGradient144 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.347,
    x2: 140.369,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient145 || (_linearGradient145 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.071,
    x2: 176.28,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient146 || (_linearGradient146 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.462,
    x2: 151.462,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient147 || (_linearGradient147 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.639,
    x2: 205.639,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient148 || (_linearGradient148 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.196,
    x2: 184.721,
    xlinkHref: "#lg2",
    y1: 169.932,
    y2: 129.457
  })), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_163_",
    cx: 202.515,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient149 || (_linearGradient149 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.815,
    x2: 197.433,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient150 || (_linearGradient150 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.524,
    x2: 194.546,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient151 || (_linearGradient151 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.248,
    x2: 230.457,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient152 || (_linearGradient152 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.639,
    x2: 205.639,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient153 || (_linearGradient153 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.816,
    x2: 259.816,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient154 || (_linearGradient154 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.374,
    x2: 238.899,
    xlinkHref: "#lg2",
    y1: 169.932,
    y2: 129.457
  })), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_170_",
    cx: 256.692,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient155 || (_linearGradient155 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.992,
    x2: 251.61,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient156 || (_linearGradient156 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.701,
    x2: 248.723,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient157 || (_linearGradient157 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.425,
    x2: 284.634,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient158 || (_linearGradient158 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.816,
    x2: 259.816,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient159 || (_linearGradient159 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.993,
    x2: 313.993,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient160 || (_linearGradient160 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.552,
    x2: 293.077,
    xlinkHref: "#lg2",
    y1: 169.933,
    y2: 129.458
  })), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_177_",
    cx: 310.869,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient161 || (_linearGradient161 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.169,
    x2: 305.787,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient162 || (_linearGradient162 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.878,
    x2: 302.9,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient163 || (_linearGradient163 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.602,
    x2: 338.811,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient164 || (_linearGradient164 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.993,
    x2: 313.993,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient165 || (_linearGradient165 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.17,
    x2: 368.17,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient166 || (_linearGradient166 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.795,
    x2: 347.712,
    xlinkHref: "#lg2",
    y1: 168.994,
    y2: 129.911
  })), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_184_",
    cx: 365.046,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient167 || (_linearGradient167 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.346,
    x2: 359.964,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient168 || (_linearGradient168 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.055,
    x2: 357.077,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient169 || (_linearGradient169 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.779,
    x2: 392.988,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient170 || (_linearGradient170 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.17,
    x2: 368.17,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _linearGradient171 || (_linearGradient171 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.662,
    x2: 422.662,
    xlinkHref: "#lg3",
    y1: 164.806,
    y2: 108.857
  })), _linearGradient172 || (_linearGradient172 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.287,
    x2: 402.204,
    xlinkHref: "#lg2",
    y1: 168.994,
    y2: 129.911
  })), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_191_",
    cx: 419.538,
    cy: 146.209,
    gradientUnits: "userSpaceOnUse",
    r: 13.518,
    xlinkHref: "#lg4"
  })), _linearGradient173 || (_linearGradient173 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.838,
    x2: 414.456,
    xlinkHref: "#lg3",
    y1: 160.545,
    y2: 138.182
  })), _linearGradient174 || (_linearGradient174 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_193_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.547,
    x2: 411.569,
    xlinkHref: "#lg5",
    y1: 152.26,
    y2: 139.282
  })), _linearGradient175 || (_linearGradient175 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.271,
    x2: 447.48,
    xlinkHref: "#lg6",
    y1: 150.783,
    y2: 133.677
  })), _linearGradient176 || (_linearGradient176 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.662,
    x2: 422.662,
    xlinkHref: "#lg7",
    y1: 147.039,
    y2: 136.809
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.87 10.711c-109.247 0-218.494 0-327.74 0-61.787 157.154-61.786 331.427 0 488.579h327.74c61.787-157.151 61.786-331.427 0-488.579z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.87 10.711c-19.515 0-39.03 0-58.545 0 39.712 157.153 39.713 331.428 0 488.579h58.545c61.787-157.151 61.786-331.427 0-488.579z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.325 10.711c-23.08 0-46.16 0-69.241 0 13.606 157.153 13.606 331.428 0 488.579h69.241c39.713-157.151 39.712-331.427 0-488.579z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.915 10.711c-23.08 0-46.16 0-69.241 0-39.713 157.154-39.712 331.427 0 488.579h69.241c-13.605-157.152-13.605-331.426 0-488.579z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.085 10.711c-24.056 0-48.113 0-72.169 0-13.606 157.154-13.605 331.427 0 488.579h72.169c13.605-157.151 13.605-331.427 0-488.579z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m418.865 499.284h-327.73c-10.581-26.922-19.357-54.351-26.317-82.116 25.614 7.879 52.773 12.105 80.906 12.105 154.949 0 280.565-128.373 280.565-286.715 0-47.532-11.316-92.373-31.364-131.842h23.939c61.788 157.142 61.788 331.426.001 488.568z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.729 166.296 176.429 176.429h232.246c7.787-58.667 7.727-118.101-.177-176.757h-408.454c-.015.109-.03.219-.044.328z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.87 10.71c-109.247 0-218.494 0-327.741 0-3.151 8.014-6.132 16.075-8.962 24.174l366.724 366.724c29.212-129.621 19.204-265.693-30.021-390.898z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m417.333 39.316h-324.666c-8.099 0-14.665-6.566-14.665-14.665v-9.985c0-8.1 6.566-14.666 14.665-14.666h324.666c8.099 0 14.665 6.566 14.665 14.665v9.985c0 8.1-6.566 14.666-14.665 14.666z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 120.111,
    cy: 21.115,
    fill: "url(#SVGID_10_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.011 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.782 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.96 21.115c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.104 18.212h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.261 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.795 21.115c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.964 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.111,
    cy: 16.472,
    fill: "url(#SVGID_16_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 174.288,
    cy: 21.115,
    fill: "url(#SVGID_17_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.188 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.782 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 174.288,
    cy: 21.115,
    fill: "url(#SVGID_19_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.281 18.212h-3.053v-3.052c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.052c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.261 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.288,
    cy: 21.115,
    fill: "url(#SVGID_21_)",
    r: 9.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.141 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.288,
    cy: 16.472,
    fill: "url(#SVGID_23_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 228.465,
    cy: 21.115,
    fill: "url(#SVGID_24_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.365 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.781 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 228.465,
    cy: 21.115,
    fill: "url(#SVGID_26_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.458 18.212h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.261 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.149 21.115c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684c5.349 0 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.318 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.465,
    cy: 16.472,
    fill: "url(#SVGID_30_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 282.642,
    cy: 21.115,
    fill: "url(#SVGID_31_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.542 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.782 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 282.642,
    cy: 21.115,
    fill: "url(#SVGID_33_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.635 18.212h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.261 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.642,
    cy: 21.115,
    fill: "url(#SVGID_35_)",
    r: 9.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.495 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_36_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.642,
    cy: 16.472,
    fill: "url(#SVGID_37_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 336.819,
    cy: 21.115,
    fill: "url(#SVGID_38_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.719 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.781 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 336.819,
    cy: 21.115,
    fill: "url(#SVGID_40_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.812 18.212h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.261 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.503 21.115c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684c5.349 0 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.672 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_43_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.819,
    cy: 16.472,
    fill: "url(#SVGID_44_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 390.996,
    cy: 21.115,
    fill: "url(#SVGID_45_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.896 13.694c-1.979-2.106-4.782-3.429-7.9-3.429-5.992 0-10.849 4.857-10.849 10.849 0 3.118 1.323 5.921 3.429 7.9l23.967 23.967c1.979 2.106 4.782 3.429 7.899 3.429 5.992 0 10.849-4.857 10.849-10.849 0-3.118-1.323-5.921-3.429-7.9z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 390.996,
    cy: 21.115,
    fill: "url(#SVGID_47_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.989 18.212h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.261 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.262 2.818-2.818 0-1.555-1.262-2.817-2.818-2.817z",
    fill: "url(#SVGID_48_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.996,
    cy: 21.115,
    fill: "url(#SVGID_49_)",
    r: 9.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.849 11.41c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.457 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.44-7.924-5.996-9.705z",
    fill: "url(#SVGID_50_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.996,
    cy: 16.472,
    fill: "url(#SVGID_51_)",
    rx: 7.336,
    ry: 5.041
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m417.333 509.995h-324.666c-8.099 0-14.665-6.566-14.665-14.665v-9.985c0-8.1 6.566-14.665 14.665-14.665h324.666c8.099 0 14.665 6.566 14.665 14.665v9.985c0 8.099-6.566 14.665-14.665 14.665z",
    fill: "url(#SVGID_52_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 120.111,
    cy: 491.794,
    fill: "url(#SVGID_53_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.419 510h-30.413l-10.311-10.31c-2.107-1.978-3.437-4.777-3.437-7.9 0-5.987 4.863-10.84 10.851-10.84 3.123 0 5.923 1.319 7.9 3.426l23.971 23.96c.531.508 1.018 1.07 1.439 1.664z",
    fill: "url(#SVGID_54_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.96 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_55_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.104 488.891h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.262 2.818-2.818v-3.052h3.053c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_56_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.795 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_57_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.964 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_58_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m127.447 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041c4.051 0 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_59_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 174.288,
    cy: 491.794,
    fill: "url(#SVGID_60_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.598 510h-30.423l-10.31-10.31c-2.097-1.978-3.426-4.777-3.426-7.9 0-5.987 4.863-10.84 10.851-10.84 3.113 0 5.923 1.319 7.9 3.426l23.96 23.96c.54.508 1.026 1.07 1.448 1.664z",
    fill: "url(#SVGID_61_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m185.137 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_62_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.281 488.891h-3.053v-3.052c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.052c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.262 2.818-2.818v-3.052h3.053c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_63_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.972 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_64_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.141 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_65_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m181.624 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_66_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 228.465,
    cy: 491.794,
    fill: "url(#SVGID_67_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.776 510h-30.423l-10.311-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.112 0 5.923 1.319 7.9 3.426l23.96 23.96c.531.508 1.017 1.07 1.449 1.664z",
    fill: "url(#SVGID_68_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m239.314 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_69_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.458 488.891h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.052h3.053c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_70_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.149 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684c5.349 0 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_71_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.318 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_72_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m235.801 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_73_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 282.642,
    cy: 491.794,
    fill: "url(#SVGID_74_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.955 510h-30.423l-10.31-10.31c-2.108-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.319 7.9 3.426l23.96 23.96c.54.508 1.026 1.07 1.448 1.664z",
    fill: "url(#SVGID_75_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m293.491 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_76_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.635 488.891h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.052h3.052c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_77_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.326 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684c5.349 0 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_78_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.495 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_79_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.978 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_80_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 336.819,
    cy: 491.794,
    fill: "url(#SVGID_81_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.133 510h-30.423l-10.31-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.319 7.89 3.426l23.971 23.96c.529.508 1.015 1.07 1.447 1.664z",
    fill: "url(#SVGID_82_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m347.668 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_83_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.812 488.891h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.052h3.052c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_84_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.503 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684c5.349 0 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_85_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.672 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_86_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m344.155 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_87_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 390.996,
    cy: 491.794,
    fill: "url(#SVGID_88_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.274 508.736c-1.816.821-3.826 1.264-5.944 1.264h-23.442l-10.311-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.84-10.84 3.123 0 5.923 1.319 7.9 3.426l23.971 23.96c.142.129.272.27.412.4z",
    fill: "url(#SVGID_89_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m401.845 491.794c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849c0-5.991 4.857-10.849 10.849-10.849s10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_90_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.989 488.891h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.052c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.052h3.052c1.556 0 2.818-1.262 2.818-2.818s-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_91_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.68 491.794c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_92_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.849 482.089c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.457 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.44-7.924-5.996-9.705z",
    fill: "url(#SVGID_93_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m398.332 487.151c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_94_)"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "m418.87 499.289c15.373-39.101 26.919-79.263 34.642-119.958h-397.024c.081.424.166.847.248 1.27l118.687 118.687c81.149.001 162.298.001 243.447.001z",
    fill: "url(#SVGID_95_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.253 380.734h-392.506c-8.099 0-14.665-6.566-14.665-14.665v-9.985c0-8.099 6.566-14.665 14.665-14.665h392.505c8.1 0 14.665 6.566 14.665 14.665v9.985c.001 8.099-6.565 14.665-14.664 14.665z",
    fill: "url(#SVGID_96_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.285,
    cy: 362.533,
    fill: "url(#SVGID_97_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.593 380.739h-30.413l-10.31-10.31c-2.107-1.978-3.437-4.777-3.437-7.9 0-5.987 4.863-10.84 10.851-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.961c.53.506 1.016 1.068 1.438 1.663z",
    fill: "url(#SVGID_98_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.285,
    cy: 362.533,
    fill: "url(#SVGID_99_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.278 359.63h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_100_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.969 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_101_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.138 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_102_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.285,
    cy: 357.889,
    fill: "url(#SVGID_103_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 151.462,
    cy: 362.533,
    fill: "url(#SVGID_104_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.771 380.739h-30.423l-10.31-10.31c-2.097-1.978-3.426-4.777-3.426-7.9 0-5.987 4.863-10.84 10.851-10.84 3.113 0 5.923 1.318 7.9 3.426l23.96 23.961c.541.506 1.027 1.068 1.448 1.663z",
    fill: "url(#SVGID_105_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m162.311 362.533c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849c5.991 0 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_106_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.455 359.63h-3.053v-3.052c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_107_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.146 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_108_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.315 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_109_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m158.797 357.889c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041c4.052.001 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_110_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205.639,
    cy: 362.533,
    fill: "url(#SVGID_111_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.95 380.739h-30.424l-10.31-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.923 1.318 7.9 3.426l23.96 23.961c.53.506 1.017 1.068 1.449 1.663z",
    fill: "url(#SVGID_112_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205.639,
    cy: 362.533,
    fill: "url(#SVGID_113_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.632 359.63h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_114_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.323 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_115_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.492 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_116_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.639,
    cy: 357.889,
    fill: "url(#SVGID_117_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 259.816,
    cy: 362.533,
    fill: "url(#SVGID_118_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.128 380.739h-30.423l-10.31-10.31c-2.108-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.318 7.9 3.426l23.96 23.961c.541.506 1.027 1.068 1.448 1.663z",
    fill: "url(#SVGID_119_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.665 362.533c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_120_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.809 359.63h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_121_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.5 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_122_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.669 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_123_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.816,
    cy: 357.889,
    fill: "url(#SVGID_124_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 313.993,
    cy: 362.533,
    fill: "url(#SVGID_125_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.307 380.739h-30.423l-10.31-10.31c-2.108-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.318 7.89 3.426l23.971 23.961c.528.506 1.015 1.068 1.447 1.663z",
    fill: "url(#SVGID_126_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 313.993,
    cy: 362.533,
    fill: "url(#SVGID_127_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.986 359.63h-3.053v-3.052c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.052h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_128_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.677 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_129_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.846 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_130_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.993,
    cy: 357.889,
    fill: "url(#SVGID_131_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 368.17,
    cy: 362.533,
    fill: "url(#SVGID_132_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.448 379.474c-1.816.821-3.826 1.264-5.944 1.264h-23.442l-10.31-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.84-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.961c.141.129.27.27.411.399z",
    fill: "url(#SVGID_133_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.019 362.533c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_134_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.163 359.63h-3.052v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_135_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.854 362.533c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.335 9.684 9.684z",
    fill: "url(#SVGID_136_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.023 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_137_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.17,
    cy: 357.889,
    fill: "url(#SVGID_138_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 422.662,
    cy: 362.533,
    fill: "url(#SVGID_139_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.94 379.474c-1.816.821-3.826 1.264-5.944 1.264h-23.442l-10.311-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.84-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.961c.142.129.271.27.412.399z",
    fill: "url(#SVGID_140_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 422.662,
    cy: 362.533,
    fill: "url(#SVGID_141_)",
    r: 10.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.655 359.63h-3.053v-3.052c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.052h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_142_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.662,
    cy: 362.533,
    fill: "url(#SVGID_143_)",
    r: 9.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.515 352.828c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.412-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.248-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_144_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.662,
    cy: 357.889,
    fill: "url(#SVGID_145_)",
    rx: 7.336,
    ry: 5.041
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.253 168.577h-392.506c-8.099 0-14.665-6.566-14.665-14.665v-9.985c0-8.099 6.566-14.665 14.665-14.665h392.505c8.1 0 14.665 6.566 14.665 14.665v9.985c.001 8.099-6.565 14.665-14.664 14.665z",
    fill: "url(#SVGID_146_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.285,
    cy: 150.376,
    fill: "url(#SVGID_147_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.593 168.582h-30.413l-10.31-10.31c-2.107-1.978-3.437-4.777-3.437-7.9 0-5.987 4.863-10.84 10.851-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.96c.53.508 1.016 1.07 1.438 1.664z",
    fill: "url(#SVGID_148_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.134 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849c5.991 0 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_149_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.278 147.473h-3.053v-3.053c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.053h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_150_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.969 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_151_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.138 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_152_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.285,
    cy: 145.733,
    fill: "url(#SVGID_153_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 151.462,
    cy: 150.376,
    fill: "url(#SVGID_154_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.771 168.582h-30.423l-10.31-10.31c-2.097-1.978-3.426-4.777-3.426-7.9 0-5.987 4.863-10.84 10.851-10.84 3.113 0 5.923 1.318 7.9 3.426l23.96 23.96c.541.508 1.027 1.07 1.448 1.664z",
    fill: "url(#SVGID_155_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m162.311 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849c5.991 0 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_156_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.455 147.473h-3.053v-3.053c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.053h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.261 2.818 2.818 2.818 1.556 0 2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_157_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.146 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_158_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.315 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_159_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m158.797 145.733c0 2.784-3.284 5.041-7.336 5.041-4.051 0-7.336-2.257-7.336-5.041s3.284-5.041 7.336-5.041 7.336 2.257 7.336 5.041z",
    fill: "url(#SVGID_160_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205.639,
    cy: 150.376,
    fill: "url(#SVGID_161_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.95 168.582h-30.424l-10.31-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.923 1.318 7.9 3.426l23.96 23.96c.53.508 1.017 1.07 1.449 1.664z",
    fill: "url(#SVGID_162_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m216.488 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849c5.991 0 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_163_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.632 147.473h-3.053v-3.053c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.053h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.261 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_164_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.323 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_165_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.492 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_166_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.639,
    cy: 145.733,
    fill: "url(#SVGID_167_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 259.816,
    cy: 150.376,
    fill: "url(#SVGID_168_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.128 168.582h-30.423l-10.31-10.31c-2.108-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.318 7.9 3.426l23.96 23.96c.541.508 1.027 1.07 1.448 1.664z",
    fill: "url(#SVGID_169_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.665 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_170_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.809 147.473h-3.052v-3.053c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.053h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_171_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.5 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_172_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.669 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_173_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.816,
    cy: 145.733,
    fill: "url(#SVGID_174_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 313.993,
    cy: 150.376,
    fill: "url(#SVGID_175_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.307 168.582h-30.423l-10.31-10.31c-2.108-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.851-10.84 3.113 0 5.912 1.318 7.89 3.426l23.971 23.96c.528.508 1.015 1.07 1.447 1.664z",
    fill: "url(#SVGID_176_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.842 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_177_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.986 147.473h-3.053v-3.053c0-1.556-1.261-2.818-2.818-2.818-1.556 0-2.818 1.262-2.818 2.818v3.053h-3.053c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.053v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_178_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.677 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_179_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.846 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_180_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.993,
    cy: 145.733,
    fill: "url(#SVGID_181_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 368.17,
    cy: 150.376,
    fill: "url(#SVGID_182_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.448 167.318c-1.816.821-3.826 1.265-5.944 1.265h-23.442l-10.31-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.84-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.96c.141.129.27.269.411.399z",
    fill: "url(#SVGID_183_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.019 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_184_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.163 147.473h-3.052v-3.053c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.053h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.052c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_185_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.854 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_186_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.023 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_187_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.17,
    cy: 145.733,
    fill: "url(#SVGID_188_)",
    rx: 7.336,
    ry: 5.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 422.662,
    cy: 150.376,
    fill: "url(#SVGID_189_)",
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.94 167.318c-1.816.821-3.826 1.265-5.944 1.265h-23.442l-10.311-10.31c-2.107-1.978-3.426-4.777-3.426-7.9 0-5.987 4.853-10.84 10.84-10.84 3.123 0 5.923 1.318 7.9 3.426l23.971 23.96c.142.129.271.269.412.399z",
    fill: "url(#SVGID_190_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m433.511 150.376c0 5.992-4.857 10.849-10.849 10.849s-10.849-4.857-10.849-10.849 4.857-10.849 10.849-10.849 10.849 4.857 10.849 10.849z",
    fill: "url(#SVGID_191_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.655 147.473h-3.053v-3.053c0-1.556-1.262-2.818-2.818-2.818s-2.818 1.262-2.818 2.818v3.053h-3.052c-1.556 0-2.818 1.262-2.818 2.818s1.262 2.818 2.818 2.818h3.052v3.053c0 1.556 1.262 2.818 2.818 2.818s2.818-1.262 2.818-2.818v-3.053h3.053c1.556 0 2.818-1.261 2.818-2.818-.001-1.556-1.262-2.818-2.818-2.818z",
    fill: "url(#SVGID_192_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.346 150.376c0 5.348-4.336 9.684-9.684 9.684s-9.684-4.336-9.684-9.684 4.336-9.684 9.684-9.684 9.684 4.336 9.684 9.684z",
    fill: "url(#SVGID_193_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.515 140.671c.732 1.46 1.144 3.108 1.144 4.853 0 5.992-4.857 10.849-10.849 10.849-1.745 0-3.393-.413-4.853-1.144 1.781 3.555 5.458 5.996 9.705 5.996 5.992 0 10.849-4.857 10.849-10.849 0-4.247-2.441-7.924-5.996-9.705z",
    fill: "url(#SVGID_194_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.662,
    cy: 145.733,
    fill: "url(#SVGID_195_)",
    rx: 7.336,
    ry: 5.041
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarrel);
export default __webpack_public_path__ + "static/media/icon-barrel.67db2b006325c6dac40a9217ac70e965.svg";
export { ForwardRef as ReactComponent };